import { ImageSources } from '../../types';
import { createSrcSet } from '../create-src-set';

/**
 * @todo подумать над кешированием результатов
 */
export const preload = (sources: ImageSources) =>
  new Promise<void>((resolve, reject) => {
    const link = document.createElement('link');

    link.addEventListener('load', () => {
      queueMicrotask(link.remove.bind(link));

      resolve();
    });

    link.addEventListener('error', (event) => {
      queueMicrotask(link.remove.bind(link));

      reject(new Error('[image]: preload failed', { cause: event }));
    });

    link.rel = 'preload';
    link.as = 'image';

    const isSvg = sources.base.endsWith('.svg');

    if (isSvg) {
      link.type = 'image/svg+xml';
      link.href = sources.base;
    } else {
      link.imageSrcset = createSrcSet(sources);
    }

    document.head.appendChild(link);
  });
